/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";

import type { RollupChain } from "../RollupChain";

export class RollupChain__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _blockChallengePeriod: BigNumberish,
    _maxPriorityTxDelay: BigNumberish,
    _transitionDisputerAddress: string,
    _registryAddress: string,
    _operator: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<RollupChain> {
    return super.deploy(
      _blockChallengePeriod,
      _maxPriorityTxDelay,
      _transitionDisputerAddress,
      _registryAddress,
      _operator,
      overrides || {}
    ) as Promise<RollupChain>;
  }
  getDeployTransaction(
    _blockChallengePeriod: BigNumberish,
    _maxPriorityTxDelay: BigNumberish,
    _transitionDisputerAddress: string,
    _registryAddress: string,
    _operator: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _blockChallengePeriod,
      _maxPriorityTxDelay,
      _transitionDisputerAddress,
      _registryAddress,
      _operator,
      overrides || {}
    );
  }
  attach(address: string): RollupChain {
    return super.attach(address) as RollupChain;
  }
  connect(signer: Signer): RollupChain__factory {
    return super.connect(signer) as RollupChain__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): RollupChain {
    return new Contract(address, _abi, signerOrProvider) as RollupChain;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_blockChallengePeriod",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_maxPriorityTxDelay",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_transitionDisputerAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_registryAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_operator",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "strategyId",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "aggregateId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "success",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sharesFromBuy",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountFromSell",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "currEpoch",
        type: "uint64",
      },
    ],
    name: "AggregationExecuted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "assetId",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "depositId",
        type: "uint64",
      },
    ],
    name: "AssetDeposited",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "assetId",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "AssetWithdrawn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousOperator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newOperator",
        type: "address",
      },
    ],
    name: "OperatorChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "blockId",
        type: "uint256",
      },
    ],
    name: "RollupBlockCommitted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "blockId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "execLen",
        type: "uint32",
      },
    ],
    name: "RollupBlockExecuted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "blockId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "reason",
        type: "string",
      },
    ],
    name: "RollupBlockReverted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [],
    name: "BLOCK_EXEC_COUNT_DONE",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "blockChallengePeriod",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "blocks",
    outputs: [
      {
        internalType: "bytes32",
        name: "rootHash",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "intentHash",
        type: "bytes32",
      },
      {
        internalType: "uint32",
        name: "intentExecCount",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "blockSize",
        type: "uint32",
      },
      {
        internalType: "uint64",
        name: "blockTime",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_blockId",
        type: "uint256",
      },
      {
        internalType: "bytes[]",
        name: "_transitions",
        type: "bytes[]",
      },
    ],
    name: "commitBlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "countExecuted",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_weth",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "depositETH",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "depositQueuePointer",
    outputs: [
      {
        internalType: "uint64",
        name: "executeHead",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "commitHead",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "tail",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "depositReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "disputePriorityTxDelay",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes",
            name: "transition",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "blockId",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "index",
            type: "uint32",
          },
          {
            internalType: "bytes32[]",
            name: "siblings",
            type: "bytes32[]",
          },
        ],
        internalType: "struct DataTypes.TransitionProof",
        name: "_prevTransitionProof",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "bytes",
            name: "transition",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "blockId",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "index",
            type: "uint32",
          },
          {
            internalType: "bytes32[]",
            name: "siblings",
            type: "bytes32[]",
          },
        ],
        internalType: "struct DataTypes.TransitionProof",
        name: "_invalidTransitionProof",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "stateRoot",
            type: "bytes32",
          },
          {
            components: [
              {
                internalType: "address",
                name: "account",
                type: "address",
              },
              {
                internalType: "uint32",
                name: "accountId",
                type: "uint32",
              },
              {
                internalType: "uint256[]",
                name: "idleAssets",
                type: "uint256[]",
              },
              {
                internalType: "uint256[]",
                name: "shares",
                type: "uint256[]",
              },
              {
                components: [
                  {
                    internalType: "uint64",
                    name: "aggregateId",
                    type: "uint64",
                  },
                  {
                    internalType: "uint256",
                    name: "buyAmount",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "sellShares",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "buyFees",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "sellFees",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "celrFees",
                    type: "uint256",
                  },
                ],
                internalType: "struct DataTypes.PendingAccountInfo[][]",
                name: "pending",
                type: "tuple[][]",
              },
              {
                internalType: "uint256[]",
                name: "stakedShares",
                type: "uint256[]",
              },
              {
                internalType: "uint256[]",
                name: "stakes",
                type: "uint256[]",
              },
              {
                internalType: "uint256[][]",
                name: "rewardDebts",
                type: "uint256[][]",
              },
              {
                internalType: "uint64",
                name: "timestamp",
                type: "uint64",
              },
            ],
            internalType: "struct DataTypes.AccountInfo",
            name: "value",
            type: "tuple",
          },
          {
            internalType: "uint32",
            name: "index",
            type: "uint32",
          },
          {
            internalType: "bytes32[]",
            name: "siblings",
            type: "bytes32[]",
          },
        ],
        internalType: "struct DataTypes.AccountProof[]",
        name: "_accountProofs",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "stateRoot",
            type: "bytes32",
          },
          {
            components: [
              {
                internalType: "uint32",
                name: "assetId",
                type: "uint32",
              },
              {
                internalType: "uint256",
                name: "assetBalance",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "shareSupply",
                type: "uint256",
              },
              {
                internalType: "uint64",
                name: "nextAggregateId",
                type: "uint64",
              },
              {
                internalType: "uint64",
                name: "lastExecAggregateId",
                type: "uint64",
              },
              {
                components: [
                  {
                    internalType: "uint64",
                    name: "aggregateId",
                    type: "uint64",
                  },
                  {
                    internalType: "uint128",
                    name: "maxSharePriceForBuy",
                    type: "uint128",
                  },
                  {
                    internalType: "uint128",
                    name: "minSharePriceForSell",
                    type: "uint128",
                  },
                  {
                    internalType: "uint256",
                    name: "buyAmount",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "sellShares",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "sharesFromBuy",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "amountFromSell",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "unsettledBuyAmount",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "unsettledSellShares",
                    type: "uint256",
                  },
                  {
                    internalType: "bool",
                    name: "executionSucceed",
                    type: "bool",
                  },
                ],
                internalType: "struct DataTypes.PendingStrategyInfo[]",
                name: "pending",
                type: "tuple[]",
              },
            ],
            internalType: "struct DataTypes.StrategyInfo",
            name: "value",
            type: "tuple",
          },
          {
            internalType: "uint32",
            name: "index",
            type: "uint32",
          },
          {
            internalType: "bytes32[]",
            name: "siblings",
            type: "bytes32[]",
          },
        ],
        internalType: "struct DataTypes.StrategyProof",
        name: "_strategyProof",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "stateRoot",
            type: "bytes32",
          },
          {
            components: [
              {
                internalType: "uint32",
                name: "strategyId",
                type: "uint32",
              },
              {
                internalType: "uint32[]",
                name: "rewardAssetIds",
                type: "uint32[]",
              },
              {
                internalType: "uint256[]",
                name: "rewardPerEpoch",
                type: "uint256[]",
              },
              {
                internalType: "uint256",
                name: "totalShares",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "totalStakes",
                type: "uint256",
              },
              {
                internalType: "uint256[]",
                name: "accumulatedRewardPerUnit",
                type: "uint256[]",
              },
              {
                internalType: "uint64",
                name: "lastRewardEpoch",
                type: "uint64",
              },
              {
                internalType: "uint256",
                name: "stakeAdjustmentFactor",
                type: "uint256",
              },
            ],
            internalType: "struct DataTypes.StakingPoolInfo",
            name: "value",
            type: "tuple",
          },
          {
            internalType: "uint32",
            name: "index",
            type: "uint32",
          },
          {
            internalType: "bytes32[]",
            name: "siblings",
            type: "bytes32[]",
          },
        ],
        internalType: "struct DataTypes.StakingPoolProof",
        name: "_stakingPoolProof",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256[]",
            name: "protoFees",
            type: "uint256[]",
          },
          {
            components: [
              {
                internalType: "uint256[]",
                name: "assets",
                type: "uint256[]",
              },
              {
                internalType: "uint256[]",
                name: "shares",
                type: "uint256[]",
              },
            ],
            internalType: "struct DataTypes.OperatorFees",
            name: "opFees",
            type: "tuple",
          },
          {
            internalType: "uint64",
            name: "currEpoch",
            type: "uint64",
          },
          {
            internalType: "uint256[]",
            name: "rewards",
            type: "uint256[]",
          },
        ],
        internalType: "struct DataTypes.GlobalInfo",
        name: "_globalInfo",
        type: "tuple",
      },
    ],
    name: "disputeTransition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "drainETH",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "drainToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    name: "execResultQueuePointers",
    outputs: [
      {
        internalType: "uint64",
        name: "executeHead",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "commitHead",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "tail",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_blockId",
        type: "uint256",
      },
      {
        internalType: "bytes[]",
        name: "_intents",
        type: "bytes[]",
      },
      {
        internalType: "uint32",
        name: "_execLen",
        type: "uint32",
      },
    ],
    name: "executeBlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getCountBlocks",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxPriorityTxDelay",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "netDepositLimits",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "netDeposits",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "operator",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "pendingDeposits",
    outputs: [
      {
        internalType: "bytes32",
        name: "ehash",
        type: "bytes32",
      },
      {
        internalType: "uint64",
        name: "blockId",
        type: "uint64",
      },
      {
        internalType: "enum RollupChain.PendingEventStatus",
        name: "status",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "pendingExecResults",
    outputs: [
      {
        internalType: "bytes32",
        name: "ehash",
        type: "bytes32",
      },
      {
        internalType: "uint64",
        name: "blockId",
        type: "uint64",
      },
      {
        internalType: "enum RollupChain.PendingEventStatus",
        name: "status",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "pendingWithdrawCommits",
    outputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "assetId",
        type: "uint32",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    name: "pendingWithdraws",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_blockChallengePeriod",
        type: "uint256",
      },
    ],
    name: "setBlockChallengePeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_maxPriorityTxDelay",
        type: "uint256",
      },
    ],
    name: "setMaxPriorityTxDelay",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_limit",
        type: "uint256",
      },
    ],
    name: "setNetDepositLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_operator",
        type: "address",
      },
    ],
    name: "setOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "address",
        name: "_weth",
        type: "address",
      },
    ],
    name: "withdrawETH",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "0x60806040523480156200001157600080fd5b5060405162005de338038062005de38339810160408190526200003491620000ee565b600080546001600160a01b031916339081178255604051909182917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908290a3506000805460ff60a01b19169055600d94909455600e92909255600180546001600160a01b039283166001600160a01b0319918216179091556002805493831693821693909317909255600f80549190931691161790556200014b565b80516001600160a01b0381168114620000e957600080fd5b919050565b600080600080600060a0868803121562000106578081fd5b85519450602086015193506200011f60408701620000d1565b92506200012f60608701620000d1565b91506200013f60808701620000d1565b90509295509295909350565b615c88806200015b6000396000f3fe60806040526004361061022f5760003560e01c8063a1545a5211610126578063cdcab4a3116100a7578063efe9f5b911610079578063f2fde38b11610061578063f2fde38b1461078e578063f940e385146107ae578063ffb9b820146107ce57005b8063efe9f5b914610714578063f25b3f991461073457005b8063cdcab4a31461069e578063dfe9fbd1146106be578063ec8dedb7146106de578063ed038f5c146106fe57005b8063b3ab15fb116100f8578063b90405da116100e0578063b90405da14610649578063c145e2a614610669578063cb5f31291461067e57005b8063b3ab15fb14610613578063b64ccb491461063357005b8063a1545a5214610526578063a35a2eda14610553578063a79327941461059d578063b0f53c11146105e657005b806370ec7372116101b05780638456cb5911610182578063911c61e21161016a578063911c61e214610483578063978d602a146104e65780639d4323be1461050657005b80638456cb59146104505780638da5cb5b1461046557005b806370ec73721461038f578063715018a6146103a55780637db4e28f146103ba57806383bc6ef6146103da57005b8063524ef2b4116102015780635c975abb116101e95780635c975abb146103185780636530267d1461034257806370d063051461036257005b8063524ef2b4146102cb578063570ca735146102e057005b806325fe0975146102385780632e599054146102835780633f4ba83a1461029657806347e7ef24146102ab57005b3661023657005b005b34801561024457600080fd5b50610270610253366004614aa2565b600a60209081526000928352604080842090915290825290205481565b6040519081526020015b60405180910390f35b610236610291366004614a77565b610804565b3480156102a257600080fd5b506102366108ff565b3480156102b757600080fd5b506102366102c6366004614a77565b610951565b3480156102d757600080fd5b50600354610270565b3480156102ec57600080fd5b50600f54610300906001600160a01b031681565b6040516001600160a01b03909116815260200161027a565b34801561032457600080fd5b50600054600160a01b900460ff16604051901515815260200161027a565b34801561034e57600080fd5b5061023661035d366004614d3d565b6109c2565b34801561036e57600080fd5b5061027061037d366004614a07565b600b6020526000908152604090205481565b34801561039b57600080fd5b50610270600e5481565b3480156103b157600080fd5b50610236610e85565b3480156103c657600080fd5b506102366103d5366004614a77565b610f24565b3480156103e657600080fd5b506104266103f5366004614e66565b6008602052600090815260409020546001600160401b0380821691600160401b8104821691600160801b9091041683565b604080516001600160401b039485168152928416602084015292169181019190915260600161027a565b34801561045c57600080fd5b50610236610f7d565b34801561047157600080fd5b506000546001600160a01b0316610300565b34801561048f57600080fd5b506104d761049e366004614e9e565b6007602090815260009283526040808420909152908252902080546001909101546001600160401b03811690600160401b900460ff1683565b60405161027a939291906155f0565b3480156104f257600080fd5b50610236610501366004614a3f565b610fcd565b34801561051257600080fd5b50610236610521366004614a77565b611135565b34801561053257600080fd5b50610270610541366004614a07565b600c6020526000908152604090205481565b34801561055f57600080fd5b5061057361056e366004614e22565b6111e1565b604080516001600160a01b03909416845263ffffffff90921660208401529082015260600161027a565b3480156105a957600080fd5b506104d76105b8366004614cc4565b600560205260009081526040902080546001909101546001600160401b03811690600160401b900460ff1683565b3480156105f257600080fd5b506105fe63ffffffff81565b60405163ffffffff909116815260200161027a565b34801561061f57600080fd5b5061023661062e366004614a07565b611234565b34801561063f57600080fd5b50610270600d5481565b34801561065557600080fd5b50610236610664366004614cc4565b6112f2565b34801561067557600080fd5b5061023661133f565b34801561068a57600080fd5b50610236610699366004614cc4565b61140f565b3480156106aa57600080fd5b506102366106b9366004614cc4565b61145c565b3480156106ca57600080fd5b506102366106d9366004614a77565b611599565b3480156106ea57600080fd5b506102366106f9366004614cf4565b6116c8565b34801561070a57600080fd5b5061027060045481565b34801561072057600080fd5b5061023661072f366004614b88565b611f1f565b34801561074057600080fd5b5061075461074f366004614cc4565b61220f565b60408051958652602086019490945263ffffffff928316938501939093521660608301526001600160401b0316608082015260a00161027a565b34801561079a57600080fd5b506102366107a9366004614a07565b612267565b3480156107ba57600080fd5b506102366107c9366004614a3f565b612393565b3480156107da57600080fd5b50600654610426906001600160401b0380821691600160401b8104821691600160801b9091041683565b600054600160a01b900460ff16156108565760405162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b60448201526064015b60405180910390fd5b60408051808201909152600e81526d1a5b9d985b1a5908185b5bdd5b9d60921b602082015234821461089b5760405162461bcd60e51b815260040161084d9190615632565b506108a7828233612402565b816001600160a01b031663d0e30db0826040518263ffffffff1660e01b81526004016000604051808303818588803b1580156108e257600080fd5b505af11580156108f6573d6000803e3d6000fd5b50505050505050565b6000546001600160a01b031633146109475760405162461bcd60e51b81526020600482018190526024820152600080516020615c33833981519152604482015260640161084d565b61094f61271e565b565b600054600160a01b900460ff161561099e5760405162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b604482015260640161084d565b6109a9828233612402565b6109be6001600160a01b0383163330846127bb565b5050565b600054600160a01b900460ff1615610a0f5760405162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b604482015260640161084d565b60045484146040518060400160405280601081526020016f1a5b9d985b1a5908189b1bd8dac8125160821b81525090610a5b5760405162461bcd60e51b815260040161084d9190615632565b5043600d5460038681548110610a8157634e487b7160e01b600052603260045260246000fd5b6000918252602090912060039091020160020154610aaf9190600160401b90046001600160401b0316615a54565b106040518060400160405280601681526020017f6368616c6c656e676520706572696f64206572726f720000000000000000000081525090610b045760405162461bcd60e51b815260040161084d9190615632565b50600060038581548110610b2857634e487b7160e01b600052603260045260246000fd5b6000918252602082206002600390920201015463ffffffff1691508315610bc65760005b84811015610bc45781868683818110610b7557634e487b7160e01b600052603260045260246000fd5b9050602002810190610b879190615981565b604051602001610b99939291906155aa565b6040516020818303038152906040528051906020012091508080610bbc90615b32565b915050610b4c565b505b60038681548110610be757634e487b7160e01b600052603260045260246000fd5b9060005260206000209060030201600101548114604051806040016040528060118152602001700d2dcecc2d8d2c840c8c2e8c240d0c2e6d607b1b81525090610c435760405162461bcd60e51b815260040161084d9190615632565b506000610c508484615a6c565b60408051808201909152601381527f696e76616c69642064617461206c656e67746800000000000000000000000000602082015290915063ffffffff8216861015610cae5760405162461bcd60e51b815260040161084d9190615632565b5063ffffffff8316610ccc57610cc38761282c565b610ccc87612a0b565b63ffffffff83165b8163ffffffff16811015610d72576000610d53888884818110610d0757634e487b7160e01b600052603260045260246000fd5b9050602002810190610d199190615981565b8080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250612af992505050565b9050610d5f818a612bbb565b5080610d6a81615b32565b915050610cd4565b5063ffffffff8116851415610deb5763ffffffff60038881548110610da757634e487b7160e01b600052603260045260246000fd5b60009182526020822060039190910201600201805463ffffffff191663ffffffff93909316929092179091556004805491610de183615b32565b9190505550610e3d565b8060038881548110610e0d57634e487b7160e01b600052603260045260246000fd5b906000526020600020906003020160020160006101000a81548163ffffffff021916908363ffffffff1602179055505b6040805188815263ffffffff831660208201527fd4f52784b1c89a2bb6b64bb2b99513cf7f2e48efe1eb45f3c10eb986f0a4bc2191015b60405180910390a150505050505050565b6000546001600160a01b03163314610ecd5760405162461bcd60e51b81526020600482018190526024820152600080516020615c33833981519152604482015260640161084d565b600080546040516001600160a01b03909116907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908390a36000805473ffffffffffffffffffffffffffffffffffffffff19169055565b600054600160a01b900460ff1615610f715760405162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b604482015260640161084d565b6109a982826000612402565b6000546001600160a01b03163314610fc55760405162461bcd60e51b81526020600482018190526024820152600080516020615c33833981519152604482015260640161084d565b61094f61321a565b600054600160a01b900460ff161561101a5760405162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b604482015260640161084d565b600061102683836132a2565b604051632e1a7d4d60e01b8152600481018290529091506001600160a01b03831690632e1a7d4d90602401600060405180830381600087803b15801561106b57600080fd5b505af115801561107f573d6000803e3d6000fd5b505050506000836001600160a01b03168260405160006040518083038185875af1925050503d80600081146110d0576040519150601f19603f3d011682016040523d82523d6000602084013e6110d5565b606091505b50509050806040518060400160405280600f81526020017f7769746864726177206661696c656400000000000000000000000000000000008152509061112e5760405162461bcd60e51b815260040161084d9190615632565b5050505050565b600054600160a01b900460ff166111855760405162461bcd60e51b815260206004820152601460248201527314185d5cd8589b194e881b9bdd081c185d5cd95960621b604482015260640161084d565b6000546001600160a01b031633146111cd5760405162461bcd60e51b81526020600482018190526024820152600080516020615c33833981519152604482015260640161084d565b6109be6001600160a01b03831633836134c5565b600960205281600052604060002081815481106111fd57600080fd5b6000918252602090912060029091020180546001909101546001600160a01b0382169350600160a01b90910463ffffffff16915083565b6000546001600160a01b0316331461127c5760405162461bcd60e51b81526020600482018190526024820152600080516020615c33833981519152604482015260640161084d565b600f54604080516001600160a01b03928316815291831660208301527fd58299b712891143e76310d5e664c4203c940a67db37cf856bdaa3c5c76a802c910160405180910390a1600f805473ffffffffffffffffffffffffffffffffffffffff19166001600160a01b0392909216919091179055565b6000546001600160a01b0316331461133a5760405162461bcd60e51b81526020600482018190526024820152600080516020615c33833981519152604482015260640161084d565b600d55565b600354156113c75760035460009061135990600190615ac7565b6006549091506001600160401b03600160801b82048116600160401b9092041610156113c557600e546006546001600160401b03600160401b90910481166000908152600560205260409020600101546113b4911683615ac7565b11156113c5576113c261321a565b50565b505b60405162461bcd60e51b815260206004820181905260248201527f4e6f7420657863656564206d6178207072696f726974792074782064656c6179604482015260640161084d565b6000546001600160a01b031633146114575760405162461bcd60e51b81526020600482018190526024820152600080516020615c33833981519152604482015260640161084d565b600e55565b600054600160a01b900460ff166114ac5760405162461bcd60e51b815260206004820152601460248201527314185d5cd8589b194e881b9bdd081c185d5cd95960621b604482015260640161084d565b6000546001600160a01b031633146114f45760405162461bcd60e51b81526020600482018190526024820152600080516020615c33833981519152604482015260640161084d565b604051600090339083908381818185875af1925050503d8060008114611536576040519150601f19603f3d011682016040523d82523d6000602084013e61153b565b606091505b50509050806040518060400160405280600c81526020017f647261696e206661696c65640000000000000000000000000000000000000000815250906115945760405162461bcd60e51b815260040161084d9190615632565b505050565b6000546001600160a01b031633146115e15760405162461bcd60e51b81526020600482018190526024820152600080516020615c33833981519152604482015260640161084d565b60025460405163639260df60e01b81526001600160a01b038481166004830152600092169063639260df9060240160206040518083038186803b15801561162757600080fd5b505afa15801561163b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061165f9190614e82565b60408051808201909152600d81526c1a5b9d985b1a5908185cdcd95d609a1b602082015290915063ffffffff82166116aa5760405162461bcd60e51b815260040161084d9190615632565b50506001600160a01b039091166000908152600c6020526040902055565b600054600160a01b900460ff16156117155760405162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b604482015260640161084d565b600f5460408051808201909152601381527f63616c6c6572206e6f74206f70657261746f72000000000000000000000000006020820152906001600160a01b031633146117755760405162461bcd60e51b815260040161084d9190615632565b5060035460408051808201909152601081526f1a5b9d985b1a5908189b1bd8dac8125160821b60208201529084146117c05760405162461bcd60e51b815260040161084d9190615632565b506000816001600160401b038111156117e957634e487b7160e01b600052604160045260246000fd5b604051908082528060200260200182016040528015611812578160200160208202803683370190505b50905060005b828110156118a55783838281811061184057634e487b7160e01b600052603260045260246000fd5b90506020028101906118529190615981565b6040516118609291906155c4565b604051809103902082828151811061188857634e487b7160e01b600052603260045260246000fd5b60209081029190910101528061189d81615b32565b915050611818565b5060006118b1826134f5565b90506000805b84811015611de05760006119308787848181106118e457634e487b7160e01b600052603260045260246000fd5b90506020028101906118f69190615981565b8080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250613c9392505050565b905060ff811660041480611947575060ff81166005145b80611955575060ff81166006145b80611963575060ff81166007145b80611971575060ff8116600a145b1561197c5750611dce565b60ff811660021415611a195760006119f98888858181106119ad57634e487b7160e01b600052603260045260246000fd5b90506020028101906119bf9190615981565b8080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250613c9a92505050565b9050611a13816040015182608001518360a001518c613d3b565b50611dcc565b60ff811660031415611b5f576000611a96888885818110611a4a57634e487b7160e01b600052603260045260246000fd5b9050602002810190611a5c9190615981565b8080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250613f3c92505050565b9050600960008a8152602001908152602001600020604051806060016040528083604001516001600160a01b03168152602001836080015163ffffffff1681526020018360c001516fffffffffffffffffffffffffffffffff168460a00151611aff9190615ac7565b90528154600181810184556000938452602093849020835160029093020180549484015163ffffffff16600160a01b026001600160c01b03199095166001600160a01b039093169290921793909317815560409091015191015550611dcc565b60ff811660081415611bcd5782878784818110611b8c57634e487b7160e01b600052603260045260246000fd5b9050602002810190611b9e9190615981565b604051602001611bb0939291906155aa565b604051602081830303815290604052805190602001209250611dcc565b60ff811660091415611c56576000611c4a888885818110611bfe57634e487b7160e01b600052603260045260246000fd5b9050602002810190611c109190615981565b8080601f01602080910402602001604051908101604052809392919081815260200183838082843760009201919091525061405392505050565b9050611a13818a614123565b60ff8116600b1415611d82576000611cd3888885818110611c8757634e487b7160e01b600052603260045260246000fd5b9050602002810190611c999190615981565b8080601f0160208091040260200160405190810160405280939291908181526020018383808284376000920191909152506143e192505050565b9050600960008a81526020019081526020016000206040518060600160405280611d056000546001600160a01b031690565b6001600160a01b03908116825260408086015163ffffffff908116602080860191909152606090970151938201939093528454600181810187556000968752958790208551600290920201805497860151909416600160a01b026001600160c01b0319909716921691909117949094178155920151910155611dcc565b60ff811660101415611dcc576000611db3888885818110611c8757634e487b7160e01b600052603260045260246000fd5b9050611dca6000826040015183606001518c613d3b565b505b505b80611dd881615b32565b9150506118b7565b506040805160a08101825283815260208101838152600082840181815263ffffffff898116606086019081526001600160401b03438116608088019081526003805460018101825596819052885196027fc2575a0e9e593c00f959f8c92f12db2869c3395a3b0502d05e2516446f71f85b81019690965595517fc2575a0e9e593c00f959f8c92f12db2869c3395a3b0502d05e2516446f71f85c86015592517fc2575a0e9e593c00f959f8c92f12db2869c3395a3b0502d05e2516446f71f85d909401805491519551909316600160401b026fffffffffffffffff0000000000000000199583166401000000000267ffffffffffffffff199092169490921693909317929092179290921617905590517f8f398593f037f47ea1fc7ede311023f216c9f01cea5795d6df8c3caf1eaecff090610e749089815260200190565b60006003886020013581548110611f4657634e487b7160e01b600052603260045260246000fd5b600091825260208083206040805160a0810182526003948502909201805483526001810154838501526002015463ffffffff8082169284019290925264010000000081049091166060830152600160401b90046001600160401b031660808201528254909450908a0135908110611fcd57634e487b7160e01b600052603260045260246000fd5b60009182526020918290206040805160a0810182526003939093029091018054835260018101549383019390935260029092015463ffffffff8082169383019390935264010000000081049092166060820152600160401b9091046001600160401b031660808201819052600d54919250439161204991615a54565b116040518060400160405280601681526020017f6368616c6c656e676520706572696f64206572726f72000000000000000000008152509061209e5760405162461bcd60e51b815260040161084d9190615632565b5060006060600160009054906101000a90046001600160a01b03166001600160a01b031663c068f81460e01b8c8c8c8c8c8c8c8c8c600260009054906101000a90046001600160a01b03166040516024016121029a99989796959493929190615645565b60408051601f198184030181529181526020820180516001600160e01b03166001600160e01b031990941693909317909252905161214091906155d4565b6000604051808303816000865af19150503d806000811461217d576040519150601f19603f3d011682016040523d82523d6000602084013e612182565b606091505b50909250905081156121ba576000818060200190518101906121a49190614aeb565b90506121b48b6020013582614456565b50612202565b60405162461bcd60e51b815260206004820152601160248201527f4661696c656420746f2064697370757465000000000000000000000000000000604482015260640161084d565b5050505050505050505050565b6003818154811061221f57600080fd5b600091825260209091206003909102018054600182015460029092015490925063ffffffff80821691640100000000810490911690600160401b90046001600160401b031685565b6000546001600160a01b031633146122af5760405162461bcd60e51b81526020600482018190526024820152600080516020615c33833981519152604482015260640161084d565b6001600160a01b03811661232b5760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201527f6464726573730000000000000000000000000000000000000000000000000000606482015260840161084d565b600080546040516001600160a01b03808516939216917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e091a36000805473ffffffffffffffffffffffffffffffffffffffff19166001600160a01b0392909216919091179055565b600054600160a01b900460ff16156123e05760405162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b604482015260640161084d565b60006123ec83836132a2565b90506115946001600160a01b03831684836134c5565b60025460405163639260df60e01b81526001600160a01b038581166004830152600092169063639260df9060240160206040518083038186803b15801561244857600080fd5b505afa15801561245c573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906124809190614e82565b905060008163ffffffff16116040518060400160405280600d81526020016c1a5b9d985b1a5908185cdcd95d609a1b815250906124d05760405162461bcd60e51b815260040161084d9190615632565b506001600160a01b0384166000908152600b60205260408120546124f5908590615a54565b9050600c6000866001600160a01b03166001600160a01b03168152602001908152602001600020548111156040518060400160405280600d81526020017f65786365656473206c696d697400000000000000000000000000000000000000815250906125745760405162461bcd60e51b815260040161084d9190615632565b506001600160a01b0385166000908152600b6020526040812082905560068054600160801b90046001600160401b03169060106125b083615b4d565b82546001600160401b039182166101009390930a92830291909202199091161790556040516bffffffffffffffffffffffff19606087901b1660208201526001600160e01b031960e086901b1660348201526038810187905290915060009060580160408051808303601f1901815282825280516020918201206060840183528084526003546001600160401b03908116838601908152600086860181815289841682526005909552949094208551815593516001808601805467ffffffffffffffff198116939094169283178155945193975092939268ffffffffffffffffff199092161790600160401b9084908111156126bc57634e487b7160e01b600052602160045260246000fd5b021790555050604080516001600160a01b038816815263ffffffff871660208201529081018890526001600160401b03841660608201527f29aa1661ba2cc554a9ea0d323ec363139ea5fc950bc9b2d03294bfc7b2ddfe7f9150608001610e74565b600054600160a01b900460ff1661276e5760405162461bcd60e51b815260206004820152601460248201527314185d5cd8589b194e881b9bdd081c185d5cd95960621b604482015260640161084d565b6000805460ff60a01b191690557f5db9ee0a495bf2e6ff9c91a7834c1ba4fdd244a5e8aa4e537bd38aeae4b073aa335b6040516001600160a01b03909116815260200160405180910390a1565b6040516001600160a01b03808516602483015283166044820152606481018290526128269085906323b872dd60e01b906084015b60408051601f198184030181529190526020810180516001600160e01b03166001600160e01b0319909316929092179091526145ee565b50505050565b604080516060810182526006546001600160401b038082168352600160401b820481166020840152600160801b90910416918101919091525b80602001516001600160401b031681600001516001600160401b031610156129ae5780516001600160401b039081166000908152600560209081526040808320815160608101835281548152600180830154968716948201949094529394909291840191600160401b90910460ff16908111156128f257634e487b7160e01b600052602160045260246000fd5b600181111561291157634e487b7160e01b600052602160045260246000fd5b905250905060018160400151600181111561293c57634e487b7160e01b600052602160045260246000fd5b14158061295557508281602001516001600160401b0316115b1561296057506129ae565b81516001600160401b03166000908152600560205260408120908155600101805468ffffffffffffffffff1916905581518261299b82615b4d565b6001600160401b03169052506128659050565b80516006805460208401516040909401516001600160401b03908116600160801b0267ffffffffffffffff60801b19958216600160401b026fffffffffffffffffffffffffffffffff199093169190941617179290921617905550565b60005b600082815260096020526040902054811015612ae1576000828152600960205260408120805483908110612a5257634e487b7160e01b600052603260045260246000fd5b6000918252602080832060408051606081018252600290940290910180546001600160a01b03811680865263ffffffff600160a01b9092048216868601908152600190930154868501819052908752600a85528387209251909116865292528320805492945090929091612ac7908490615a54565b90915550829150612ad9905081615b32565b915050612a0e565b5060008181526009602052604081206113c291614925565b6040805160e081018252600080825260208201819052918101829052606081018290526080810182905260a0810182905260c081019190915260008060008060008087806020019051810190612b4f9190614ebb565b955095509550955095509550600080612b708863ffffffff602082901c1691565b6040805160e08101825260ff9092168252602082019990995263ffffffff9091169781019790975250506060850193909352608084019190915260a083015260c08201529392505050565b6040828101516002549151635a2f9ddb60e11b815263ffffffff8216600482015290916000916001600160a01b039091169063b45f3bb69060240160206040518083038186803b158015612c0e57600080fd5b505afa158015612c22573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612c469190614a23565b60408051808201909152601081527f696e76616c69642073747261746567790000000000000000000000000000000060208201529091506001600160a01b038216612ca45760405162461bcd60e51b815260040161084d9190615632565b506000819050612d34828660600151836001600160a01b031663670ab5e96040518163ffffffff1660e01b815260040160206040518083038186803b158015612cec57600080fd5b505afa158015612d00573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612d249190614a23565b6001600160a01b031691906146d3565b6060850151608086015160a087015160c088015160405160009485946001600160a01b038916946309de5f1160e21b94612d869460240193845260208401929092526040830152606082015260800190565b60408051601f198184030181529181526020820180516001600160e01b03166001600160e01b0319909416939093179092529051612dc491906155d4565b6000604051808303816000865af19150503d8060008114612e01576040519150601f19603f3d011682016040523d82523d6000602084013e612e06565b606091505b50915091506000808315612e2e5782806020019051810190612e289190614e43565b90925090505b63ffffffff87166000908152600860209081526040808320815160608101835290546001600160401b038082168352600160401b8204811694830194909452600160801b9004909216908201818152919291612e8982615b4d565b6001600160401b0316905260405160e08b901b6001600160e01b031916602082015260c082811b6001600160c01b0319908116602484015289151560f81b602c840152602d8301889052604d8301879052439182901b16606d83015291925060009060750160408051601f19818403018152828252805160209182012060608401909252818352600354919350820190612f2590600190615ade565b6001600160401b031681526020016000905263ffffffff8c1660009081526007602090815260408083206001600160401b0388811685529083529281902084518155918401516001808401805467ffffffffffffffff19811693909616928317815592860151939468ffffffffffffffffff191690911790600160401b908490811115612fc257634e487b7160e01b600052602160045260246000fd5b0217905550506040805163ffffffff8e1681526001600160401b0386811660208301528b151582840152606082018a905260808201899052851660a082015290517f6acdbb389d9a584e9de895303931184de1fc009e63bfc574840e915f1fc061ed92509081900360c00190a15b83602001516001600160401b031684600001516001600160401b031610156131965763ffffffff8b16600090815260076020908152604080832087516001600160401b03908116855290835281842082516060810184528154815260018083015493841695820195909552939092840191600160401b900460ff16908111156130c957634e487b7160e01b600052602160045260246000fd5b60018111156130e857634e487b7160e01b600052602160045260246000fd5b905250905060018160400151600181111561311357634e487b7160e01b600052602160045260246000fd5b14158061312c57508c81602001516001600160401b0316115b156131375750613196565b63ffffffff8c16600090815260076020908152604080832088516001600160401b031684529091528120908155600101805468ffffffffffffffffff1916905584518561318382615b4d565b6001600160401b03169052506130309050565b50505063ffffffff90971660009081526008602090815260409182902089518154928b015193909a01516001600160401b03908116600160801b0267ffffffffffffffff60801b19948216600160401b026fffffffffffffffffffffffffffffffff1990941691909b16179190911791909116979097179096555050505050505050565b600054600160a01b900460ff16156132675760405162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b604482015260640161084d565b6000805460ff60a01b1916600160a01b1790557f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a25861279e3390565b60025460405163639260df60e01b81526001600160a01b038381166004830152600092839291169063639260df9060240160206040518083038186803b1580156132eb57600080fd5b505afa1580156132ff573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906133239190614e82565b905060008163ffffffff16116040518060400160405280600d81526020016c1a5b9d985b1a5908185cdcd95d609a1b815250906133735760405162461bcd60e51b815260040161084d9190615632565b506001600160a01b0384166000908152600a6020908152604080832063ffffffff85168452825291829020548251808401909352600e83526d1a5b9d985b1a5908185b5bdd5b9d60921b9183019190915290816133e35760405162461bcd60e51b815260040161084d9190615632565b506001600160a01b0384166000908152600b6020526040902054811115613422576001600160a01b0384166000908152600b6020526040812055613450565b6001600160a01b0384166000908152600b60205260408120805483929061344a908490615ac7565b90915550505b6001600160a01b0385166000818152600a6020908152604080832063ffffffff87168085529083528184209390935580519384529083019190915281018290527fa8d2059deb1787b03478662fb43905086ccfe9e47b2e454d0186076b495395869060600160405180910390a1949350505050565b6040516001600160a01b03831660248201526044810182905261159490849063a9059cbb60e01b906064016127ef565b6000808251116135475760405162461bcd60e51b815260206004820152601160248201527f4d65726b6c653a206e6f206c6561766573000000000000000000000000000000604482015260640161084d565b815160011415613581578160008151811061357257634e487b7160e01b600052603260045260246000fd5b60200260200101519050919050565b60408051610400810182527f290decd9548b62a8d60345a988386fc84ba6bc95484008f6362f93160ef3e56381527f633dc4d7da7256660a892f8f1604a44b5432649cc8ec5cb3ced4c4e6ac94dd1d60208201527f890740a8eb06ce9be422cb8da5cdafc2b58c0a5e24036c578de2a433c828ff7d818301527f3b8ec09e026fdc305365dfc94e189a81b38c7597b3d941c279f042e8206e0bd86060808301919091527fecd50eee38e386bd62be9bedb990706951b65fe053bd9d8a521af753d139e2da60808301527fdefff6d330bb5403f63b14f33b578274160de3a50df4efecf0e0db73bcdd3da560a08301527f617bdd11f7c0a11f49db22f629387a12da7596f9d1704d7465177c63d88ec7d760c08301527f292c23a9aa1d8bea7e2435e555a4a60e379a5a35f3f452bae60121073fb6eead60e08301527fe1cea92ed99acdcb045a6726b2f87107e8a61620a232cf4d7d5b5766b3952e106101008301527f7ad66c0a68c72cb89e4fb4303841966e4062a76ab97451e3b9fb526a5ceb7f826101208301527fe026cc5a4aed3c22a58cbd3d2ac754c9352c5436f638042dca99034e836365166101408301527f3d04cffd8b46a874edf5cfae63077de85f849a660426697b06a829c70dd1409c6101608301527fad676aa337a485e4728a0b240d92b3ef7b3c372d06d189322bfd5f61f1e7203e6101808301527fa2fca4a49658f9fab7aa63289c91b7c7b6c832a6d0e69334ff5b0a3483d09dab6101a08301527f4ebfd9cd7bca2505f7bef59cc1c12ecc708fff26ae4af19abe852afe9e20c8626101c08301527f2def10d13dd169f550f578bda343d9717a138562e0093b380a1120789d53cf106101e08301527f776a31db34a1a0a7caaf862cffdfff1789297ffadc380bd3d39281d340abd3ad6102008301527fe2e7610b87a5fdf3a72ebe271287d923ab990eefac64b6e59d79f8b7e08c46e36102208301527f504364a5c6858bf98fff714ab5be9de19ed31a976860efbd0e772a2efe23e2e06102408301527f4f05f4acb83f5b65168d9fef89d56d4d77b8944015e6b1eed81b0238e2d0dba36102608301527f44a6d974c75b07423e1d6d33f481916fdd45830aea11b6347e700cd8b9f0767c6102808301527fedf260291f734ddac396a956127dde4c34c0cfb8d8052f88ac139658ccf2d5076102a08301527f6075c657a105351e7f0fce53bc320113324a522e8fd52dc878c762551e01a46e6102c08301527f6ca6a3f763a9395f7da16014725ca7ee17e4815c0ff8119bf33f273dee11833b6102e08301527f1c25ef10ffeb3c7d08aa707d17286e0b0d3cbcb50f1bd3b6523b63ba3b52dd0f6103008301527ffffc43bd08273ccf135fd3cacbeef055418e09eb728d727c4d5d5c556cdea7e36103208301527fc5ab8111456b1f28f3c7a0a604b4553ce905cb019c463ee159137af83c350b226103408301527f0ff273fcbf4ae0f2bd88d6cf319ff4004f8d7dca70d4ced4e74d2c74139739e66103608301527f7fa06ba11241ddd5efdc65d4e39c9f6991b74fd4b81b62230808216c876f827c6103808301527f7e275adf313a996c7e2950cac67caba02a5ff925ebf9906b58949f3e77aec5b96103a08301527f8f6162fa308d2b3a15dc33cffac85f13ab349173121645aedf00f471663108be6103c08301527f78ccaaab73373552f207a63599de54d7d8d0c1805f86ce7da15818d09f4cff626103e083015282518381529081018352909160009190602082018180368337505085519192506000918291508180805b6001841115613c5b57613aa2600285615a94565b9150613aaf600285615b74565b600114905060005b82811015613b85578a613acb826002615aa8565b81518110613ae957634e487b7160e01b600052603260045260246000fd5b602002602001015196508a816002613b019190615aa8565b613b0c906001615a54565b81518110613b2a57634e487b7160e01b600052603260045260246000fd5b6020026020010151955086602089015285604089015287805190602001208b8281518110613b6857634e487b7160e01b600052603260045260246000fd5b602090810291909101015280613b7d81615b32565b915050613ab7565b508015613c2b5789613b98600186615ac7565b81518110613bb657634e487b7160e01b600052603260045260246000fd5b60200260200101519550878360208110613be057634e487b7160e01b600052603260045260246000fd5b602002015160001b945085602088015284604088015286805190602001208a8381518110613c1e57634e487b7160e01b600052603260045260246000fd5b6020026020010181815250505b80613c37576000613c3a565b60015b613c479060ff1683615a54565b935082613c5381615b32565b935050613a8e565b89600081518110613c7c57634e487b7160e01b600052603260045260246000fd5b602002602001015198505050505050505050919050565b6020015190565b6040805160c081018252600080825260208201819052918101829052606081018290526080810182905260a081019190915260008060008085806020019051810190613ce69190614c7c565b6040805160c08101825260ff8616815260208101949094526001600160a01b039092168383015263ffffffff606085811c8216908501529390911c909216608082015260a08101919091529695505050505050565b604080516060810182526006546001600160401b038082168352600160401b820481166020808501829052600160801b9093049091168385018190528451808601909552601285527f696e76616c6964206465706f73697420746e0000000000000000000000000000928501929092529192908210613dcd5760405162461bcd60e51b815260040161084d9190615632565b506040516bffffffffffffffffffffffff19606088901b1660208201526001600160e01b031960e087901b1660348201526038810185905260009060580160408051601f1981840301815282825280516020918201206001600160401b0386166000908152600583528390205484840190935260118452700d2dcecc2d8d2c840c8c2e8c240d0c2e6d607b1b9184019190915292508214613e815760405162461bcd60e51b815260040161084d9190615632565b506001600160401b038281166000908152600560209081526040909120600101805492871668ffffffffffffffffff1990931692909217600160401b179091558301805190613ecf82615b4d565b6001600160401b0390811690915284516006805460208801516040909801519284166fffffffffffffffffffffffffffffffff1990911617600160401b978416979097029690961767ffffffffffffffff60801b1916600160801b91909216021790935550505050505050565b6040805161016081018252600080825260208201819052918101829052606081018290526080810182905260a0810182905260c0810182905260e081018290526101008101829052610120810182905261014081019190915260008060008060008087806020019051810190613fb29190614d99565b604080516101608101825260ff888116825260208201979097526001600160a01b03959095169085015260e086811c606086015260c087811c63ffffffff1660808088019190915285811c60a08801526fffffffffffffffffffffffffffffffff909516908601529286901c6001600160401b03169284019290925261010083015261012082015260089290921c1661014082015298975050505050505050565b6040805161010081018252600080825260208201819052918101829052606081018290526080810182905260a0810182905260c0810182905260e0810191909152600080600080858060200190518101906140ae9190614ded565b604080516101008101825260ff86811682526020808301969096529486901c63ffffffff16818301526001600160401b039186901c82166060820152600886901c90941660011460808086019190915260a085019390935260c084019190915292901c90911660e08201529695505050505050565b60408083015163ffffffff1660009081526008602090815290829020825160608101845290546001600160401b038082168352600160401b82048116838501819052600160801b909204168285018190528451808601909552601285527f696e76616c6964206578656352657320746e0000000000000000000000000000938501939093529092909182106141cb5760405162461bcd60e51b815260040161084d9190615632565b5060008460400151856060015186608001518760a001518860c001518960e0015160405160200161424b9695949392919060e09690961b6001600160e01b031916865260c094851b6001600160c01b0319908116600488015293151560f81b600c870152600d860192909252602d85015290911b16604d82015260550190565b60408051601f1981840301815282825280516020918201208883015163ffffffff166000908152600783528381206001600160401b038816825283528390205484840190935260118452700d2dcecc2d8d2c840c8c2e8c240d0c2e6d607b1b91840191909152925082146142d25760405162461bcd60e51b815260040161084d9190615632565b506040858101805163ffffffff9081166000908152600760208181528583206001600160401b038981168086529183528785206001908101805468ff00000000000000001916600160401b17905596519095168452918152858320918352908152939020909101805467ffffffffffffffff1916918716919091179055830180519061435d82615b4d565b6001600160401b0390811690915260409687015163ffffffff1660009081526008602090815290889020865181549288015199909701518316600160801b0267ffffffffffffffff60801b19998416600160401b026fffffffffffffffffffffffffffffffff19909316979093169690961717969096169590951790925550505050565b6040805160808101825260008082526020820181905291810182905260608101919091526000806000808580602001905181019061441f9190614f0d565b6040805160808101825260ff9095168552602085019390935263ffffffff9091169183019190915260608201529695505050505050565b61445e61321a565b6003548210156144e35760035460099060009061447d90600190615ac7565b81526020015260038054806144a257634e487b7160e01b600052603160045260246000fd5b600082815260208120600360001990930192830201818155600181019190915560020180546fffffffffffffffffffffffffffffffff19169055905561445e565b6006546000906001600160401b03165b6006546001600160401b03600160801b909104811690821610156145af576001600160401b0380821660009081526005602052604090206001015416841161459d578161456957600680546fffffffffffffffff00000000000000001916600160401b6001600160401b03841602179055600191505b6001600160401b038181166000908152600560205260409020600101805468ffffffffffffffffff19169186169190911790555b806145a781615b4d565b9150506144f3565b507f36a66b31987e7e6abdbfed3b1968c201f8c3a138705e5087cd66e221faf1e1ff83836040516145e1929190615968565b60405180910390a1505050565b6000614643826040518060400160405280602081526020017f5361666545524332303a206c6f772d6c6576656c2063616c6c206661696c6564815250856001600160a01b03166147949092919063ffffffff16565b80519091501561159457808060200190518101906146619190614acf565b6115945760405162461bcd60e51b815260206004820152602a60248201527f5361666545524332303a204552433230206f7065726174696f6e20646964206e60448201527f6f74207375636365656400000000000000000000000000000000000000000000606482015260840161084d565b604051636eb1769f60e11b81523060048201526001600160a01b038381166024830152600091839186169063dd62ed3e9060440160206040518083038186803b15801561471f57600080fd5b505afa158015614733573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906147579190614cdc565b6147619190615a54565b6040516001600160a01b03851660248201526044810182905290915061282690859063095ea7b360e01b906064016127ef565b60606147a384846000856147ad565b90505b9392505050565b6060824710156148255760405162461bcd60e51b815260206004820152602660248201527f416464726573733a20696e73756666696369656e742062616c616e636520666f60448201527f722063616c6c0000000000000000000000000000000000000000000000000000606482015260840161084d565b843b6148735760405162461bcd60e51b815260206004820152601d60248201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e7472616374000000604482015260640161084d565b600080866001600160a01b0316858760405161488f91906155d4565b60006040518083038185875af1925050503d80600081146148cc576040519150601f19603f3d011682016040523d82523d6000602084013e6148d1565b606091505b50915091506148e18282866148ec565b979650505050505050565b606083156148fb5750816147a6565b82511561490b5782518084602001fd5b8160405162461bcd60e51b815260040161084d9190615632565b50805460008255600202906000526020600020908101906113c291905b808211156149675780546001600160c01b031916815560006001820155600201614942565b5090565b803561497681615bca565b919050565b60008083601f84011261498c578182fd5b5081356001600160401b038111156149a2578182fd5b6020830191508360208260051b85010111156149bd57600080fd5b9250929050565b803561497681615bdf565b6000608082840312156149e0578081fd5b50919050565b803561497681615bed565b803561497681615c0b565b803561497681615c1d565b600060208284031215614a18578081fd5b81356147a681615bca565b600060208284031215614a34578081fd5b81516147a681615bca565b60008060408385031215614a51578081fd5b8235614a5c81615bca565b91506020830135614a6c81615bca565b809150509250929050565b60008060408385031215614a89578182fd5b8235614a9481615bca565b946020939093013593505050565b60008060408385031215614ab4578182fd5b8235614abf81615bca565b91506020830135614a6c81615c0b565b600060208284031215614ae0578081fd5b81516147a681615bdf565b600060208284031215614afc578081fd5b81516001600160401b0380821115614b12578283fd5b818401915084601f830112614b25578283fd5b815181811115614b3757614b37615bb4565b604051601f8201601f19908116603f01168101908382118183101715614b5f57614b5f615bb4565b81604052828152876020848701011115614b77578586fd5b6148e1836020830160208801615b06565b600080600080600080600060c0888a031215614ba2578283fd5b87356001600160401b0380821115614bb8578485fd5b614bc48b838c016149cf565b985060208a0135915080821115614bd9578485fd5b614be58b838c016149cf565b975060408a0135915080821115614bfa578485fd5b614c068b838c0161497b565b909750955060608a0135915080821115614c1e578485fd5b614c2a8b838c016149cf565b945060808a0135915080821115614c3f578384fd5b614c4b8b838c016149cf565b935060a08a0135915080821115614c60578283fd5b50614c6d8a828b016149cf565b91505092959891949750929550565b60008060008060808587031215614c91578182fd5b8451614c9c81615bed565b602086015160408701519195509350614cb481615bca565b6060959095015193969295505050565b600060208284031215614cd5578081fd5b5035919050565b600060208284031215614ced578081fd5b5051919050565b600080600060408486031215614d08578081fd5b8335925060208401356001600160401b03811115614d24578182fd5b614d308682870161497b565b9497909650939450505050565b60008060008060608587031215614d52578182fd5b8435935060208501356001600160401b03811115614d6e578283fd5b614d7a8782880161497b565b9094509250506040850135614d8e81615c0b565b939692955090935050565b60008060008060008060c08789031215614db1578384fd5b86519550602087015194506040870151614dca81615bca565b80945050606087015192506080870151915060a087015190509295509295509295565b60008060008060808587031215614e02578182fd5b505082516020840151604085015160609095015191969095509092509050565b60008060408385031215614e34578182fd5b50508035926020909101359150565b60008060408385031215614e55578182fd5b505080516020909101519092909150565b600060208284031215614e77578081fd5b81356147a681615c0b565b600060208284031215614e93578081fd5b81516147a681615c0b565b60008060408385031215614eb0578182fd5b8235614a9481615c0b565b60008060008060008060c08789031215614ed3578384fd5b8651614ede81615c1d565b6020880151604089015160608a015160808b015160a0909b0151939c929b509099909850965090945092505050565b60008060008060808587031215614f22578182fd5b845160ff81168114614f32578283fd5b602086015160408701519195509350614cb481615c0b565b81835260006020808501808196508560051b8101915084845b87811015614fcc5782840389528135601e19883603018112614f83578687fd5b870180356001600160401b03811115614f9a578788fd5b60c081023603891315614fab578788fd5b614fb88682898501615075565b9a87019a9550505090840190600101614f63565b5091979650505050505050565b81835260006020808501808196508560051b8101915084845b87811015614fcc57828403895261500982886159c5565b615014868284615028565b9a87019a9550505090840190600101614ff2565b81835260007f07ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff831115615059578081fd5b8260051b80836020870137939093016020019283525090919050565b81835260006020808501945082825b858110156150e457813561509781615c1d565b6001600160401b03168752818301358388015260408083013590880152606080830135908801526080808301359088015260a0808301359088015260c09687019690910190600101615084565b509495945050505050565b81835260006020808501945082825b858110156150e45761512087615113846149fc565b6001600160401b03169052565b61512b8383016149e6565b6fffffffffffffffffffffffffffffffff1683880152604061514e8382016149e6565b6fffffffffffffffffffffffffffffffff1690880152606082810135908801526080808301359088015260a0808301359088015260c0808301359088015260e0808301359088015261010080830135908801526101206151af8184016149c4565b1515908801526101409687019691909101906001016150fe565b81835260006020808501945082825b858110156150e45781356151eb81615c0b565b63ffffffff16875295820195908201906001016151d8565b6000815180845261521b816020860160208601615b06565b601f01601f19169290920160200192915050565b600061523b82836159c5565b6080855261524d608086018284615028565b9150506020830135603e19843603018112615266578283fd5b8482036020860152830161527a81806159c5565b6040845261528c604085018284615028565b91505061529c60208301836159c5565b925083820360208501526152b1828483615028565b935050505060408301356152c481615c1d565b6001600160401b031660408501526152df60608401846159c5565b85830360608701526152f2838284615028565b9695505050505050565b803582526000602082013560fe19833603018112615318578182fd5b82810190506080602085015261533e60808501615334836149f1565b63ffffffff169052565b61534b60208201826159c5565b6101008060a0880152615363610180880183856151c9565b925061537260408501856159c5565b9250607f19808986030160c08a015261538c858584615028565b9450606086013560e08a01526080860135838a01526153ae60a08701876159c5565b9450925080898603016101208a015250506153ca838383615028565b925050506153da60c083016149fc565b6001600160401b031661014086015260e0820135610160860152615400604085016149f1565b63ffffffff81166040870152915061541b60608501856159c5565b925085820360608701526152f2828483615028565b803582526000602082013560be1983360301811261544c578182fd5b608060208501528201803561546081615c0b565b63ffffffff166080850152602081013560a0850152604081013560c085015261548b606082016149fc565b6001600160401b031660e08501526154a5608082016149fc565b6001600160401b03166101008501526154c160a0820182615a0c565b915060c06101208601526154da610140860183836150ef565b9150506154e9604084016149f1565b63ffffffff1660408501526152df60608401846159c5565b60008135601e19833603018112615516578182fd5b820180356001600160401b0381111561552d578283fd5b80360384131561553b578283fd5b60808552806080860152806020830160a087013784810160a00183905260208481013590860152601f01601f191684019050615579604084016149f1565b63ffffffff16604085015261559160608401846159c5565b60a08684030160608701526152f260a084018284615028565b838152818360208301376000910160200190815292915050565b8183823760009101908152919050565b600082516155e6818460208701615b06565b9190910192915050565b8381526001600160401b0383166020820152606081016002831061562457634e487b7160e01b600052602160045260246000fd5b826040830152949350505050565b6020815260006147a66020830184615203565b6102208152600061565a61022083018d615501565b828103602084015261566c818d615501565b83810360408501528a8152905060208082019060058c901b8301018c845b8d81101561587857848303601f19018452368f9003607e19018235126156ae578586fd5b8e82350180358452602081013561011e198236030181126156cd578788fd5b8181019050608060208601526156f6608086016156e98361496b565b6001600160a01b03169052565b615702602082016149f1565b63ffffffff1660a086015261571a60408201826159c5565b61012060c08801526157316101a088018284615028565b91505061574160608301836159c5565b607f19808985030160e08a0152615759848385615028565b935061576860808601866159c5565b9350915080898503016101008a0152615782848484614f4a565b935061579160a08601866159c5565b9350915080898503016101208a01526157ab848484615028565b93506157ba60c08601866159c5565b9350915080898503016101408a01526157d4848484615028565b93506157e360e08601866159c5565b9350915080898503016101608a0152506157fe838383614fd9565b9250505061580f61010083016149fc565b6001600160401b038116610180880152915061582d604084016149f1565b63ffffffff81166040880152915061584860608401846159c5565b93509150858103606087015261585f818484615028565b602097880197909650949094019350505060010161568a565b5050848103606086015261588c818c615430565b9250505082810360808401526158a281896152fc565b905082810360a08401526158b6818861522f565b865160c0850152602087015160e0850152604087015163ffffffff90811661010086015260608801511661012085015260808701516001600160401b031661014085015291506159039050565b83516101608301526020840151610180830152604084015163ffffffff9081166101a08401526060850151166101c083015260808401516001600160401b03166101e08301526001600160a01b0383166102008301529b9a5050505050505050505050565b8281526040602082015260006147a36040830184615203565b6000808335601e19843603018112615997578283fd5b8301803591506001600160401b038211156159b0578283fd5b6020019150368190038213156149bd57600080fd5b6000808335601e198436030181126159db578283fd5b83016020810192503590506001600160401b038111156159fa57600080fd5b8060051b36038313156149bd57600080fd5b6000808335601e19843603018112615a22578283fd5b83016020810192503590506001600160401b03811115615a4157600080fd5b610140810236038313156149bd57600080fd5b60008219821115615a6757615a67615b88565b500190565b600063ffffffff808316818516808303821115615a8b57615a8b615b88565b01949350505050565b600082615aa357615aa3615b9e565b500490565b6000816000190483118215151615615ac257615ac2615b88565b500290565b600082821015615ad957615ad9615b88565b500390565b60006001600160401b0383811690831681811015615afe57615afe615b88565b039392505050565b60005b83811015615b21578181015183820152602001615b09565b838111156128265750506000910152565b6000600019821415615b4657615b46615b88565b5060010190565b60006001600160401b0380831681811415615b6a57615b6a615b88565b6001019392505050565b600082615b8357615b83615b9e565b500690565b634e487b7160e01b600052601160045260246000fd5b634e487b7160e01b600052601260045260246000fd5b634e487b7160e01b600052604160045260246000fd5b6001600160a01b03811681146113c257600080fd5b80151581146113c257600080fd5b6fffffffffffffffffffffffffffffffff811681146113c257600080fd5b63ffffffff811681146113c257600080fd5b6001600160401b03811681146113c257600080fdfe4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572a26469706673582212201cb5bdafbfee0cb78f891266e21a7554f757726a74790f57d047b8a72600c18b64736f6c63430008040033";
